import { render } from "./FormatMessage.vue?vue&type=template&id=5a0a3911"
import script from "./FormatMessage.vue?vue&type=script&lang=js"
export * from "./FormatMessage.vue?vue&type=script&lang=js"

import "./FormatMessage.vue?vue&type=style&index=0&id=5a0a3911&lang=css"

import exportComponent from "C:\\Projects\\swing_vue_chat\\chat_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__